import React, { useMemo } from "react";
import { Tabs, Box } from "orcs-design-system";
import { map, capitalize, pick } from "lodash";
import PATHS, { url } from "src/consts/urlPaths";
import { useWorkspaceFeatureFlags } from "src/contexts/global/WorkspaceContext";

export const WORKSPACE_SETTINGS_TABS = {
  DETAILS: "details",
  BRANDING: "branding",
  WORKSPACE_COMMUNICATIONS: "workspace-communications",
  CUSTOMER_SUPPORT_LINKS: "custom-support-links",
  FEATURE_TOGGLES: "feature-toggles",
};

export const CUSTOMER_SUPPORT_LINKS_TAB_LABEL = "Help and links";
export const COMMUNICATIONS_TAB_LABEL = "Communications";

export const getTabLabel = (tab) => {
  if (tab === WORKSPACE_SETTINGS_TABS.CUSTOMER_SUPPORT_LINKS) {
    return CUSTOMER_SUPPORT_LINKS_TAB_LABEL;
  }
  if (tab === WORKSPACE_SETTINGS_TABS.WORKSPACE_COMMUNICATIONS) {
    return COMMUNICATIONS_TAB_LABEL;
  }
  return capitalize(tab.replaceAll("-", " "));
};

export const WorkspaceSettingsTabs = () => {
  const { enableWorkspaceSettings, enableCustomHelpAndLinks } =
    useWorkspaceFeatureFlags();

  const visibleTabs = useMemo(() => {
    if (enableWorkspaceSettings) {
      // When workspace settings is enabled, show all tabs except CUSTOMER_SUPPORT_LINKS
      // unless enableCustomHelpAndLinks is also enabled
      if (enableCustomHelpAndLinks) {
        return WORKSPACE_SETTINGS_TABS;
      }
      return pick(WORKSPACE_SETTINGS_TABS, [
        "DETAILS",
        "BRANDING",
        "WORKSPACE_COMMUNICATIONS",
        "FEATURE_TOGGLES",
      ]);
    }
    // When workspace settings is disabled, show tabs except branding and CUSTOMER_SUPPORT_LINKS
    // unless enableCustomHelpAndLinks is enabled
    const tabsWithoutBranding = pick(WORKSPACE_SETTINGS_TABS, [
      "DETAILS",
      "WORKSPACE_COMMUNICATIONS",
      "FEATURE_TOGGLES",
    ]);
    if (enableCustomHelpAndLinks) {
      return {
        ...tabsWithoutBranding,
        CUSTOMER_SUPPORT_LINKS: WORKSPACE_SETTINGS_TABS.CUSTOMER_SUPPORT_LINKS,
      };
    }
    return tabsWithoutBranding;
  }, [enableWorkspaceSettings, enableCustomHelpAndLinks]);

  return (
    <Box mb="r" boxBorder="default" borderTop="none" borderBottom="none">
      <Tabs
        tabsList={map(visibleTabs, (tab) => ({
          label: getTabLabel(tab),
          path: url(PATHS.WORKSPACE_SETTINGS, { tabType: tab }),
        }))}
      />
    </Box>
  );
};
